import React from "react";
import { useMutation } from "react-query";

import * as api from "../../services";
import usePublicMoodboards from "./usePublicMoodboards";

export default function useSavePublicMoodboard() {
  const { refetchPublicMoodboards } = usePublicMoodboards();

  // server state
  const saveMutation = useMutation(
    (data) => {
      return api.postPublicMoodboard(data);
    },
    {
      onSuccess: (data) => {
        if (data.data?.status > 0) {
          refetchPublicMoodboards(); // refresh the list of public moodboards
        }
      },
    }
  );
  return saveMutation;
}
